export * from './dokReestrInfoDossier.component';
